<template>
  <div class="AppMenuMobile">
    <div class="titleBar" >
      <div class="left" :style="{ flexGrow: isPortraitOrientation ? 1 : 0 }">
        <i :class="fullscreenIconClass" @click="toggleFullscreen()"></i>
      </div>
      <div class="center" :style="{ flexGrow: isPortraitOrientation ? 0 : 1 }">
        <AppMenuTitleBox></AppMenuTitleBox>
        <Dropdown v-if="!isPortraitOrientation" v-model="selectedTableOption" style="flex-grow: 1;"
          :options="tableOptions"
          :option-label="'label'"
          :pt="{ wrapper: { style: { maxHeight: '85vh' } } }"
        ></Dropdown>
      </div>
      <div class="right" :style="{ flexGrow: isPortraitOrientation ? 1 : 0 }">
        <i v-if="store.showAdvanced" class="pi pi-wrench"></i>
      </div>
    </div>
    <Dropdown v-model="selectedTableOption" v-if="isPortraitOrientation"
      :options="tableOptions"
      :option-label="'label'"
      :pt="{ wrapper: { style: { maxHeight: '85vh' } } }"
    ></Dropdown>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useFullscreen, useScreenOrientation } from "@vueuse/core";
import store from "./store.js";
import router from "./router.js";
import AppMenuTitleBox from "./AppMenuTitleBox.vue";
import { handleAdvancedToggleClick } from "./appUtility.js";

const { orientation } = useScreenOrientation();
const isPortraitOrientation = computed(() => orientation.value.includes("portrait"));
const titleBarPadding = computed(() => isPortraitOrientation.value ? '10px' : '0');

let boardsOnSite = computed(() => {
  return store.sessions[0].system.boardsOnSite.children;
});

let tableOptions = computed(() => {
  let system = store.sessions[0].system;
  let settingsMenuItems = system.settingsMenu.value.map(item => ({
    label: item.label,
    value: item.url
  }));
  let technicianMenuItems = system.technicianMenu.value.map(item => ({
    label: item.label, 
    value: item.url
  }));

  let combinedMenuItems = [
    { label: "Status", value: "/" },
    ... settingsMenuItems,
    { label: "Records", value: "/records" },
    ... (store.showAdvanced ? technicianMenuItems : []),
    { label: "Save and load settings", value: "/saveAndLoadSettings" }
  ];
  
  return combinedMenuItems;
});

let route = null;
let selectedTableOption = computed({
  get: () => {
    route = route ?? useRoute();
    return tableOptions.value.find(option => option.value == route.path) ?? tableOptions.value[0];
  },
  set: (option) => {
    router.push(option.value);
  }
});

let { isFullscreen, toggle: toggleFullscreen } = useFullscreen();
let fullscreenIconClass = computed(() => {
  return {
    'pi': true,
    'pi-window-maximize': !isFullscreen.value,
    'pi-window-minimize': isFullscreen.value
  };
});
</script>

<style scoped>
.AppMenuMobile {
  display: flex;
  flex-direction: column;
}
.AppMenuMobile div.titleBar {
  padding: 10px;
  padding-top: v-bind('titleBarPadding');
  padding-bottom: v-bind('titleBarPadding');
  text-align: center;
  font-size: large;
  background: #0063B1;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 20px;
}
.p-dropdown {
  margin: 5px;
}

.left {
  flex-basis: 0;
  text-align: left;
}
.center {
  flex-basis: 0;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.right {
  flex-basis: 0;
  text-align: right;
}
</style>